import styled from '@emotion/styled';
import { breakpoints } from 'gatsby-theme-apollo';

const MainColumn = styled.div({
  flex: 4,
  width: `100%`,
  flexGrow: 1,
  flexShrink: 0,
  borderRadius: `${props => props.theme.radius}`,
  backgroundColor: `${props => props.theme.backgroundDarkSemiTransparent}`,
  [breakpoints.lg]: {
    minWidth: `100%`,
    width: `100%`,
    flexGrow: 1
  }
});

const SecondaryColumn = styled.div({
  flex: 1,
  flexShrink: 1,
  flexGrow: 0,
  minWidth: `280px`,
  marginLeft: `10px`,
  flexDirection: `column`,
  display: `flex`,
  [breakpoints.lg]: {
    maxWidth: `920px`,
    minWidth: `100%`,
    marginLeft: `0px`,
    flexGrow: 1,
    marginTop: `20px`
  }
});
const TwoColumn = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
`;

export { MainColumn, SecondaryColumn, TwoColumn };
